function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { TooltipEl } from "common/components/tooltip";
import { BillingFrequency } from "media/js/pricing/api/types";
import { toCurrency } from "media/js/pricing/plan-builder-2023/common/util";
import { PACKAGE_ID_TO_LINK } from "media/js/pricing/plan-builder-2023/types";
import { CheckboxEl } from "common/components/checkbox";
import { TrackingEvents } from "media/js/pricing/tracking";
export function template() {
  const selectedPricingCurve = this.app.helpers.getCurrentPricingCurve();
  const selectedPlanState = this.app.helpers.getSelectedPlanState();
  const userLacksBillingPerms = this.helpers.userLacksBillingPermissions();
  const packages = selectedPricingCurve.packages.map((packageOption) => {
    var _selectedPlanState$pa;
    const selected = (_selectedPlanState$pa = selectedPlanState.packageIds) === null || _selectedPlanState$pa === void 0 ? void 0 : _selectedPlanState$pa.includes(packageOption.id);
    const isAnnual = selectedPlanState.billingFrequency === BillingFrequency.ANNUAL;
    return /* @__PURE__ */ jsx("div", { sel: ".package-option-wrapper", on: _objectSpread({}, this.attr("mp-2023-style") && {
      click: () => this.helpers.handlePackageClick(packageOption.id),
      keydown: (ev) => {
        (ev.key === "Enter" || ev.key === " ") && this.helpers.handlePackageClick(packageOption.id);
      }
    }) }, /* @__PURE__ */ jsx("div", { sel: ".package-option-top-row" }, this.attr("mp-2023-style") ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".package-option-title" }, packageOption.name), /* @__PURE__ */ jsx(CheckboxEl, { sel: ".package-option-checkbox", attrs: {
      checked: selected,
      "checked-color": "#7856ff",
      // $purple100
      tabindex: 0,
      "style-override": ".mp-checkbox-wrapper .mp-checkbox-icon {margin-right: 0px;}"
    } })) : /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", { sel: ".mp-font-size-medium.package-option-title" }, packageOption.name), /* @__PURE__ */ jsx("div", { sel: ".package-option-pricing" }, /* @__PURE__ */ jsx("div", { sel: ".mp-font-size-medium.package-option-price" }, "".concat(toCurrency(this.app.helpers.getPackagePrice(packageOption.id)), " ").concat(isAnnual ? "per year" : "per month")), /* @__PURE__ */ jsx("div", { sel: ".package-option-plan-pct" }, "(", packageOption.basePlanPct * 100, "% of base plan)"))), !this.attr("mp-2023-style") && /* @__PURE__ */ jsx(ButtonEl, { attrs: {
      theme: ButtonTheme.Secondary
    }, on: {
      click: () => this.helpers.handlePackageClick(packageOption.id)
    } }, selected ? /* @__PURE__ */ jsx(null, null, "Remove") : "Add")), this.attr("mp-2023-style") && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".package-option-pricing" }, /* @__PURE__ */ jsx("div", { sel: ".package-option-price" }, toCurrency(this.app.helpers.getPackagePrice(packageOption.id))), /* @__PURE__ */ jsx("div", { sel: ".package-option-plan-pct" }, packageOption.basePlanPct * 100, "% of base plan ", isAnnual ? "per year" : "per month")), /* @__PURE__ */ jsx("div", { sel: ".horizontal-line" })), /* @__PURE__ */ jsx("div", { sel: ".package-option-description" }, packageOption.description), !this.attr("mp-2023-style") && /* @__PURE__ */ jsx("a", { sel: ".package-option-link", attrs: {
      href: PACKAGE_ID_TO_LINK[packageOption.id],
      target: "_blank"
    } }, /* @__PURE__ */ jsx("div", { sel: ".package-option-learn-more" }, "Learn More"), " ", /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
      icon: "arrow-right"
    } })));
  });
  const adminInfoCard = () => {
    return userLacksBillingPerms && this.state.owners && /* @__PURE__ */ jsx("div", { sel: ".info-area" }, "Please contact your org owner to make changes to your plan: ", this.state.owners.map((owner, index) => /* @__PURE__ */ jsx(null, null, index > 0 && /* @__PURE__ */ jsx(null, null, ", "), /* @__PURE__ */ jsx("a", { attrs: {
      href: "mailto:".concat(owner.email)
    } }, owner.email))));
  };
  return /* @__PURE__ */ jsx("div", { sel: this.attr("mp-2023-style") && ".package-step-wrapper", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".step-title" }, this.attr("mp-2023-style") ? "Customize your plan with additional features" : "Customize Your Plan With Additional Features"), /* @__PURE__ */ jsx("div", { sel: ".step-description" }, "Add-ons are optional and give you access to more Mixpanel features. They are priced as a percentage of your base (Events) plan. You can choose to add or remove an add-on at any time throughout your billing cycle."), /* @__PURE__ */ jsx("div", { sel: ".package-options" }, packages), this.attr("mp-2023-style") && adminInfoCard(), /* @__PURE__ */ jsx("div", { sel: ".button-tooltip-area" }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: this.attr("mp-2023-style") ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
    role: "button",
    tabindex: 0,
    disabled: userLacksBillingPerms,
    size: ButtonSize.Large
  }, on: {
    click: () => this.helpers.handleContinue()
  }, sel: ".continue-button", "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, this.attr("unauthed") ? "Sign Up or Log In to Continue" : "Continue"), userLacksBillingPerms && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    text: "Please contact your org owner to make changes to your plan."
  } })), this.attr("mp-2023-style") && /* @__PURE__ */ jsx("a", { sel: ".support-button", attrs: {
    role: "button",
    tabindex: 0,
    href: "/get-support",
    target: "_blank"
  }, on: {
    click: () => this.app.helpers.trackEventWithPlanProps(TrackingEvents.ContactSupport)
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "brand-help"
  } }), "Contact support"), !this.attr("mp-2023-style") && userLacksBillingPerms && this.state.owners && /* @__PURE__ */ jsx("div", { sel: ".info-icon-area" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  }, sel: ".info-icon" }), /* @__PURE__ */ jsx("div", null, "Please contact your org owner (", this.state.owners.map((owner, index) => /* @__PURE__ */ jsx(null, null, index > 0 && /* @__PURE__ */ jsx(null, null, ", "), /* @__PURE__ */ jsx("a", { attrs: {
    href: "mailto:".concat(owner.email)
  } }, owner.email))), ") to make changes to your plan."))));
}
